import src from "IMAGE";
export default { src, width: 814, height: 118, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mMQCSirAGFh/+JSYd/CYiHvvAIhr5xcIY/MbJGQ2noApFsKNbl7VvYAAAAASUVORK5CYII="};
